require("./apps");
require("./employees");
require("./jobs");
require("./reports");
require("./navbar");
require("./settings");
require("./message_templates");
require("./alert_center");
require("./customize_site_template.coffee");
require("./evaluations.coffee");
require("./local_iframe.coffee");
require("./manage.coffee");
require("./welcome.coffee");
require("../global/icon_picker_widget.coffee");
require("./completed_forms.coffee")
